import type { ComponentChildren, VNode } from 'preact';
import './MasterDetail.css';

// R1b — the TABLET/DESKTOP master-detail layout for the list→detail flows
// (Auditions→AuditionDetail, Projects→ProjectDetail). The list lives in a
// narrower left pane (with its stage/phase Strip pinned above it); the
// detail — the EXISTING detail screen rendered verbatim, or a calm empty
// state — fills the right pane. Each pane owns its own scroll (min-height:0
// + the screen root's own flex:1/overflow-y:auto), so the page body never
// scrolls sideways. Phone never renders this: App.tsx only builds it under
// isRail(breakpoint); the same routes render full-screen on phone.
export interface MasterDetailProps {
  /** The list pane's sub-nav (a <Strip>), pinned above the scrolling list. */
  strip: VNode | null;
  /** The list screen (Auditions / Projects), which owns its own scroll. */
  list: ComponentChildren;
  /** The detail screen (verbatim) when an item is selected, else an empty
   *  state. Announced politely so a selection change is picked up by AT. */
  detail: ComponentChildren;
}

export function MasterDetail({ strip, list, detail }: MasterDetailProps) {
  return (
    <div class="master-detail">
      <div class="master-detail__master">
        {strip ? <div class="master-detail__strip">{strip}</div> : null}
        <div class="master-detail__list">{list}</div>
      </div>
      <div class="master-detail__detail" aria-live="polite">
        {detail}
      </div>
    </div>
  );
}
